export default class BaseCameraStreamAction {
    #cameraStream;
    #action;
    #actionArguments;

    constructor(cameraStream, action, initialArgs = [], onCompletion) {
        this.#cameraStream = cameraStream;
        this.#action = action;
        this.#actionArguments = { args: initialArgs, onCompletion };
    }

    update(args = [], onCompletion = () => {}) {
        this.#actionArguments = { args, onCompletion };
    }
    async execute() {
        if (!this.shouldExecute) return;
        const action = this.#action;
        const actionArguments = this.#actionArguments?.args;
        const onCompletion = this.#actionArguments?.onCompletion;
        this.remove();
        await this.#cameraStream[action](...actionArguments);
        onCompletion?.();
    }
    get shouldExecute() {
        return !!this.#actionArguments;
    }
    remove() {
        this.#actionArguments = null;
    }
}
